import React from 'react';
import { formatNumberByLanguage } from '../../../../utils/usefulFunctions';
import CardList from './CardList';
import useLanguage from '../../../../customHooks/useLanguage';

const PerRoom = ({ price }) => {
    const language = useLanguage();

    const items = [
        <>
            <i style={{ fontSize: 18 }} className='ms-Icon ms-Icon--Hotel' />
            <span>{formatNumberByLanguage(price, language)}</span>
        </>,
    ];
    return <CardList items={items} />;
};

export default PerRoom;
